// src/utils/useWompiCheckout.js
import { useState } from 'react';
import api from './api';

// Flujo de pago compartido entre Checkout.js (carrito) y las landing pages (one-click).
// pedidoPayload: shape esperado por POST /api/pedidos (ver backend/routes/pedidos.js)
// Devuelve { pagar, loading } — pagar() resuelve con { numero, total, transaccion_id } al aprobar,
// o lanza un error (ya con mensaje listo para mostrar al usuario) si falla o el usuario cancela.
export function useWompiCheckout() {
  const [loading, setLoading] = useState(false);

  const pagar = (pedidoPayload) => new Promise(async (resolve, reject) => {
    if (!window.WidgetCheckout) {
      reject(new Error('Error al cargar Wompi. Recarga la página.'));
      return;
    }
    setLoading(true);
    try {
      const r = await api.post('/pedidos', pedidoPayload);
      const wompiR = await api.post('/wompi/crear-transaccion', {
        pedido_id: r.data.id,
        total: r.data.total,
        email: pedidoPayload.email_cliente,
        nombre: pedidoPayload.nombre_cliente,
        telefono: pedidoPayload.telefono_cliente || '',
      });
      const w = wompiR.data;
      setLoading(false);

      const checkout = new window.WidgetCheckout({
        currency: 'COP',
        amountInCents: w.amount_in_cents,
        reference: w.referencia,
        publicKey: w.public_key,
        redirectUrl: w.redirect_url,
        signature: { integrity: w.signature },
        customerData: {
          email: w.customer_data.email,
          fullName: w.customer_data.full_name,
          phoneNumber: w.customer_data.phone_number,
          phoneNumberPrefix: '+57',
        },
      });

      checkout.open(async function (result) {
        const tx = result?.transaction;
        if (tx && tx.status === 'APPROVED') {
          try {
            await api.post('/wompi/confirmar-pago', { referencia: w.referencia, transaccion_id: tx.id });
          } catch (e) { /* el webhook de Wompi confirma igual si esta llamada falla */ }
          resolve({ numero: r.data.numero, total: r.data.total, transaccion_id: tx.id });
        } else {
          reject(new Error('Pago no completado. Intenta de nuevo.'));
        }
      });
    } catch (err) {
      setLoading(false);
      reject(new Error(err.response?.data?.error || 'Error al procesar el pedido'));
    }
  });

  return { pagar, loading };
}
